import React, { useState, useEffect } from 'react';

const SystemContext = React.createContext({  
    navItems: [],
    setNavItems: null,
    parentNav: [],
    setParentNav: null,
});

export default SystemContext;
